import { Component, OnInit, Input } from '@angular/core';
import { ProjectInfoComponent } from '../project.info.component';
import { Quote } from '../../../models/quote.interface';

@Component({
  selector: 'app-project-info-desktop',
  templateUrl: './project-info-desktop.component.html',
  styleUrls: ['./project-info-desktop.component.scss']
})
export class ProjectInfoDesktopComponent extends ProjectInfoComponent implements OnInit {


  ngOnInit(): void {
    super.ngOnInit();
  }
}
